import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './ExchangeHolidays.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner'
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function HistoricalReturn(props) {
    const [data, setData] = useState([]);
    let optionInfoMarket = "Exchange Holidays";
    // const [valuebtn, setValueBtn] = useState("Gain");
    let optionTypeComp = "Daily Market Tracker";
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [valueLy, setValueLy] = useState("M1");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "ExchangeHolidays";

            fetch(`${getUrl}/${groupValue}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //  console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
        else {
            const getUrl = BaseURL + "ExchangeHolidays";
            fetch(`${getUrl}/${groupValue}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("Exchange Holidays",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Exchange Holidays</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Exchange Holidays</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='gainer-table-main'>
                                <div className='exchange-right exchange'>
                                    <div className='holidays-inner-select'>
                                        <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>

                                        </select>
                                    </div>
                                </div>
                                <div className='exchange-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left' rowspan="2">Holiday Date</th>
                                                <th className='text-left' rowspan="2">Purpose</th>
                                                <th className='text-left' rowspan="2">Day</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ holidaydate1, Purpose, days }) => (
                                                    <tr>
                                                        <td className="text-left">{holidaydate1} </td>
                                                        <td className="text-left"> {Purpose}</td>
                                                        <td className="text-left"> {days}</td>


                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default HistoricalReturn;